// Wishlist

//Executed after SWYM has loaded all necessary resources.
function onSwymLoadCallback(swat) {
  // Please make all SWYM-related API calls inside this function.
  // You can use the swat argument within this scope.
  if (swat) {
    swat.evtLayer.addEventListener('sw:addedtocart', function (e) {
      $('.swym-close-btn').click();
      document.querySelector('body').dispatchEvent(
        new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: 1234,
            quantity: 1,
          },
        })
      );
    });
  }
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(onSwymLoadCallback);

// anchor
window.addEventListener('load', function () {
  // Check if there is a hash in the URL
  if (window.location.hash) {
    // Get the target element by its ID
    var targetElement = document.getElementById(window.location.hash.substring(1));

    // Check if the target element exists
    if (targetElement) {
      // Scroll to the target element
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    }
  }
});

function removeTrailingSlash(url) {
  return url.replace(/\/$/, ''); // This regex matches a trailing slash at the end of the string
}

// plp - filters
window.addEventListener('load', function () {
  $('#collection-filter-drawer .Collapsible__Button').each(function () {
    let filterHeading = $(this);
    if (filterHeading.text() == 'Category') {
      $('.buddha-menu-item a').each(function () {
        let navItem = $(this);
        let urlPath = removeTrailingSlash(window.location.pathname);

        if (navItem.attr('href') == urlPath) {
          let subCats = navItem.parent().find('.mm-submenu > li .mm-title');
          let subCatsLabel = subCats
            .map(function () {
              return $(this).text().toLowerCase();
            })
            .get();

          let filterItems = filterHeading.next().find('.Linklist__Item');
          // Filter and remove non-matching items
          filterItems.each(function () {
            if (subCatsLabel.indexOf($(this).find('button').text().toLowerCase()) === -1) {
              $(this).remove();
            }
          });

          //get updated list
          filterItems = filterHeading.next().find('.Linklist__Item');

          if (filterItems.length > 0) {
            // Sort items based on subCatsLabel order
            filterItems.sort(function (a, b) {
              let indexA = subCatsLabel.indexOf($(a).find('button').text().toLowerCase());
              let indexB = subCatsLabel.indexOf($(b).find('button').text().toLowerCase());
              return indexA - indexB;
            });

            // Append the sorted items back to the DOM
            filterItems.appendTo(filterHeading.next());
          } else {
            filterHeading.parent().remove();
          }

          return false;
        }
      });

      return false;
    }
  });

  //remove filter link if no filter available
  if ($('#collection-filter-drawer .Drawer__Main .Collapsible__Inner .Linklist__Item ').length <= 0) {
    $('.CollectionToolbar__Item--filter').remove();
  }
});

// wholesale page
window.addEventListener('load', function () {
  setTimeout(function () {
    $('#wsg-signup-link').insertAfter('.wsg-login-container #recover_password');
    $('#wsg-signup-container .wsg-signup-link').insertAfter('#wsg-signup-container .wsg-one-half:not(.wsg-center)');
    $('#wsg-account-create #submit-block').after(
      '<p id="wsg-stockist-link-uk">Would you like to be a UK stockist? Please contact our UK distributor at <a href="mailto:enquiries@mombooks.com">enquiries@mombooks.com</a>.</p>'
    );
  }, 2000);
});

//footer
$('.footer-menu h2').click(function () {
  $(this).toggleClass('open');
});
